import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

export default {

    path: '/marketing',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['marketing'], countries: ['RU'] },
    // component:() => import('../components/pages/cashdesk/CashdeskGeneral.vue'),
    component: () => import('../components/pages/marketing/MarketingGeneral.vue'),
    children: [
        { path: '', redirect: '/marketing/notifications' },
        {
            path: 'groups', name: "MarketingGroups",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['marketing'] },
            component: () => import('../components/pages/marketing/MarketingGroups.vue')
        },
        {
            path: 'groups/:id', name: "MarketingGroup",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['marketing'] },
            component: () => import('../components/pages/marketing/MarketingGroup.vue')
        },
        {
            path: 'groups/:id/add', name: "MarketingGroupAdd",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['marketing'] },
            component: () => import('../components/pages/marketing/MarketingGroupAdd.vue')
        },
        {
            path: 'mailing', name: "MarketingMailing",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['marketing'] },
            component: () => import('../components/pages/marketing/MarketingMailing.vue')
        },
        {
            path: 'mailing/:id', name: "MarketingMailingItem",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['marketing'] },
            component: () => import('../components/pages/marketing/MarketingMailingItem.vue')
        },
        {
            path: 'notifications', name: "MarketingNotifications",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['marketing'] },
            component: () => import('../components/pages/marketing/MarketingNotifications.vue')
        },
        {
            path: 'mailing_report', name: "MarketingMailingReport",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['marketing'] },
            component: () => import('../components/pages/marketing/MarketingMailingReport.vue')
        },
        {
            path: 'settings', name: "MarketingSettings",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'marketing'] },
            component: () => import('../components/pages/settings/SettingsMarketing.vue')
        },
    ]

}
